import InputText from "../../../../components/inputs/yup/materialui/inputText";
import { Resolver, useForm } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect, useState } from "react";
import validaRut from "../../../../utils/validaRut";
import { useToast } from "../../../../hooks/useToast";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import { Dialog, DialogContent, DialogTitle, FormHelperText } from "@mui/material";
import Grid from '@mui/material/Grid2';
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { Dominios, EnumTipoEstadoRegistro, StatusCode } from "../../../../utils/enums";
import { responsables, responsablesCrear, responsablesEditar, responsablesModal } from "../models/responsables";
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import { AxiosResponse } from "axios";
import { getValoresDominio } from "../../../../services/servicesDominio";
import { selectorTransversal } from "../../../../dtos/selector";
import { useResponsable } from "../hooks/useResponsables";
import Validaciones from "../../../../utils/validaciones";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";


interface IProps {
    show: boolean
    datosEditar: responsables | undefined
    onHide: () => void
    refresh: () => void
    setisloading: (loading: boolean) => void
    setrefresh: (value: boolean) => void
}

const ModalResponsables: React.FC<IProps> = ({ show, datosEditar, onHide, refresh, setisloading, setrefresh }) => {
    const { save } = useResponsable();
    const validationSchema = yup.object({
        id: yup.number().nullable().notRequired(),
        rut: yup.string().required('Campo requerido').test('valida-rut', 'RUT inválido', value => validaRut.rutFormat(value)),
        nombres: yup.string().required('Campo requerido').max(30, 'Máximo 30 caracteres'),
        apellidoPaterno: yup.string().required('Campo requerido').max(30, 'Máximo 30 caracteres'),
        apellidoMaterno: yup.string().required('Campo requerido').max(30, 'Máximo 30 caracteres'),    
        estado: yup.boolean().required('Campo requerido'),
        email: yup.string().nullable().test('valida-email', 'Email inválido', function (value) {
            return Validaciones.esValidoEmail(value ?? '');
        }),
        responsabilidad: yup.string().required('Campo requerido')
    });

    const [options, setOptions] = useState<selectorTransversal[]>([]);
    const tiposResponsables = async () => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_RESPONSABLE)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptions(data)
        }
        return;
    }

    useEffect(() => {
        tiposResponsables();
    }, []);

    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
    } = useForm<responsables>({
        resolver: yupResolver(validationSchema) as Resolver<responsables>
    })

    const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false)
    const { addToast } = useToast();

    useEffect(() => {
        reset()
    }, [isSubmitSuccessful])

    useEffect(() => {
        if (datosEditar && show) {
            setValue('rut', datosEditar.rut);
            setValue('nombres', datosEditar.nombres);
            setValue('apellidoPaterno', datosEditar.apellidoPaterno);
            setValue('apellidoMaterno', datosEditar.apellidoMaterno);
            setValue('email', datosEditar.email ?? '');
            setValue('estado', datosEditar.estado);
            setValue('responsabilidad', datosEditar.idResponsabilidad?.toString() ?? '');

        } else {
            reset();
            setValue('estado', true);
        }
    }, [datosEditar, show]);


    function customOnHide() {
        reset()
        onHide()
    }

    async function onSubmit(data: responsables) {
        const response = await save(data, datosEditar);
        if (response.status === StatusCode.NoContent) {

            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: datosEditar ?
                'Responsable modificado con exito.'
                :'Responsable creado con exito.'
            });
        }
        setrefresh(true)
        setIsSubmitSuccessful(true)
        refresh();
        onHide();
        reset();
    }
    return (
        <Dialog
            open={show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>
                {datosEditar ? 'Editar Responsable' : 'Nuevo Responsable'}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid size={3}>
                            <InputRut name="rut" control={control} readonly={datosEditar != null} label='RUT' error={errors.rut} />
                        </Grid>
                        <Grid size={3}>
                            <InputText name="nombres" control={control} label="Nombre" error={errors.nombres} />
                        </Grid>
                        <Grid size={3}>
                            <InputText name="apellidoPaterno" control={control} label="Apellido Paterno" error={errors.apellidoPaterno} />
                        </Grid>
                        <Grid size={3}>
                            <InputText name="apellidoMaterno" control={control} label="Apellido Materno" error={errors.apellidoMaterno} />
                        </Grid>
                        <Grid size={3}>
                            <InputText name="email" control={control} label="Email" error={errors.email} />
                        </Grid>
                        <Grid size={3}>
                            <InputSelect
                                name="responsabilidad"
                                control={control}
                                options={options}
                                readonly={datosEditar != null}
                                label="Responsabilidad"
                                error={errors.responsabilidad}
                            />
                        </Grid>

                        <Grid size={3}>
                            <InputSwitch
                                name="estado"
                                control={control}
                                label="Estado"
                                error={errors.estado}
                            />
                        </Grid>
                    </Grid>
                </form>
                <Grid container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                    <Grid>
                        <MButton variant="contained" onClick={handleSubmit(onSubmit)}>Guardar</MButton>
                    </Grid>
                    <Grid>
                        <MButton variant="contained" color="inherit" onClick={customOnHide}>Cancelar</MButton>
                    </Grid>
                </Grid>

            </DialogContent>
        </Dialog>
    )
}

export default ModalResponsables

